import { Chip } from '@material-ui/core';
import { Select, SelectArrowDownIcon, Typography } from '@room-match/shared-ui-components';
import { AiOutlineMinusCircle } from 'react-icons/ai';
import { ColorGauge } from 'shared/enums/Color';

import { ContentContainer, MainContainer, Label, TwoColumn, FlexColumn, ChipsContainer } from './JobPreferences.styles';

const mockData = [
  {
    key: 'All',
    value: 'All',
  },
];

const mockDocuments = ['Passport'];

const mockWillingness = ['Work with dogs', 'Sexual situations'];

const JobPreferences = () => {
  const handleProfessionDelete = () => {};
  return (
    <MainContainer>
      <Typography fontSize={25}>Job Preferences</Typography>
      <Typography>Show me projects that suit the following criteria:</Typography>
      <ContentContainer>
        <TwoColumn>
          <FlexColumn>
            <Label>Category</Label>
            <Select
              variant="outlined"
              data={mockData}
              IconComponent={SelectArrowDownIcon}
              name="preferred_contact_method"
              fullWidth
              value={'All'}
            />
          </FlexColumn>
          <FlexColumn>
            <Label>Job Type</Label>
            <Select
              variant="outlined"
              data={mockData}
              IconComponent={SelectArrowDownIcon}
              name="preferred_contact_method"
              fullWidth
              value={'All'}
            />
          </FlexColumn>
        </TwoColumn>
        <TwoColumn>
          <FlexColumn>
            <Label>Gender</Label>
            <Select
              variant="outlined"
              data={mockData}
              IconComponent={SelectArrowDownIcon}
              name="preferred_contact_method"
              fullWidth
              value={'All'}
            />
          </FlexColumn>
          <FlexColumn>
            <Label>Paid</Label>
            <Select
              variant="outlined"
              data={mockData}
              IconComponent={SelectArrowDownIcon}
              name="preferred_contact_method"
              fullWidth
              value={'All'}
            />
          </FlexColumn>
        </TwoColumn>
        <TwoColumn>
          <FlexColumn>
            <Label>Age Range</Label>
            <TwoColumn>
              <Select
                variant="outlined"
                data={[{ key: '20', value: 20 }]}
                IconComponent={SelectArrowDownIcon}
                fullWidth
                value={'20'}
              />
              <Select
                variant="outlined"
                data={[{ key: '40', value: 40 }]}
                IconComponent={SelectArrowDownIcon}
                fullWidth
                value={'40'}
              />
            </TwoColumn>
          </FlexColumn>
          <FlexColumn>
            <Label>Location</Label>
            <Select
              variant="outlined"
              data={mockData}
              IconComponent={SelectArrowDownIcon}
              name="preferred_contact_method"
              fullWidth
              value={'All'}
            />
          </FlexColumn>
        </TwoColumn>
        <TwoColumn>
          <FlexColumn>
            <Label>Extras Work</Label>
            <Select
              variant="outlined"
              data={[
                { key: 'Yes', value: 'Yes' },
                { key: 'No', value: 'No' },
              ]}
              IconComponent={SelectArrowDownIcon}
              name="preferred_contact_method"
              fullWidth
              value={'All'}
            />
          </FlexColumn>
          <FlexColumn>
            <Label>Union Affiliations</Label>
            <Select
              variant="outlined"
              data={mockData}
              IconComponent={SelectArrowDownIcon}
              name="preferred_contact_method"
              fullWidth
              value={'All'}
            />
          </FlexColumn>
        </TwoColumn>
        <FlexColumn>
          <Label>Area</Label>
          <Select
            variant="outlined"
            data={mockData}
            IconComponent={SelectArrowDownIcon}
            name="preferred_contact_method"
            fullWidth
            value={'All'}
          />
        </FlexColumn>
        <TwoColumn>
          <FlexColumn>
            <Label>Documents</Label>
            <Select
              variant="outlined"
              data={mockData}
              IconComponent={SelectArrowDownIcon}
              name="preferred_contact_method"
              fullWidth
              placeHolder="Select"
            />
            <ChipsContainer>
              {mockDocuments.map((i) => (
                <Chip
                  deleteIcon={<AiOutlineMinusCircle color={ColorGauge.FAIL} />}
                  key={i}
                  label={i}
                  onDelete={() => handleProfessionDelete()}
                />
              ))}
            </ChipsContainer>
          </FlexColumn>
          <FlexColumn>
            <Label>Union Affiliations</Label>
            <Select
              variant="outlined"
              data={mockData}
              IconComponent={SelectArrowDownIcon}
              name="preferred_contact_method"
              fullWidth
              placeHolder="Select"
            />
            <ChipsContainer>
              {mockWillingness.map((i) => (
                <Chip
                  deleteIcon={<AiOutlineMinusCircle color={ColorGauge.FAIL} />}
                  key={i}
                  label={i}
                  onDelete={() => handleProfessionDelete()}
                />
              ))}
            </ChipsContainer>
          </FlexColumn>
        </TwoColumn>
      </ContentContainer>
    </MainContainer>
  );
};

export default JobPreferences;
